export default [
  {
    path: "/objective-type",
    name: "ObjectiveType",
    component: () => import("@/views/Page/ObjectiveType/ObjectiveType.vue"),
    meta: {
      title: "GRC | ObjectiveType",
    },
  },
];
